<template>
    <div>
        <modal name="modal-other-sign">
            <div class="pb-4 mb-4 border-b border-gray-200">
                <div class="flex items-center justify-between">
                    <h3 class="text-xl font-bold">Autre enseigne</h3>
                    <button class="text-lg text-red-500" @click="$modal.hide('modal-other-sign')"><i class="fas fa-times"></i></button>
                </div>
            </div>
            <sav-input v-model="newSign.name" class="mb-3" label="Nom de l'enseigne" type="text" />
            <button @click="addNewSign" class="px-4 py-2 rounded-lg bg-green-500 hover:bg-green-600 cursor-pointer duration-200 mt-2 text-white">Valider <i class="fas fa-check ml-1"></i></button>
        </modal>

        <modal name="modal-other-website">
            <div class="pb-4 mb-4 border-b border-gray-200">
                <div class="flex items-center justify-between">
                    <h3 class="text-xl font-bold">Autre site web</h3>
                    <button class="text-lg text-red-500" @click="$modal.hide('modal-other-website')"><i class="fas fa-times"></i></button>
                </div>
            </div>
            <sav-input v-model="newWebsite.url" class="mb-3" label="Url du site internet" type="text" />
            <button @click="addNewWebsite" class="px-4 py-2 rounded-lg bg-green-500 hover:bg-green-600 cursor-pointer duration-200 mt-2 text-white">Valider <i class="fas fa-check ml-1"></i></button>
        </modal>

        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            {{$t('form.garantie.sign.ou_avez_vous_achete_votre_produit')}}
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <div class="font-bold flex items-center" v-if="selected">
                    <img v-if="selected.img" :src="selected.img" class="h-6 mr-2" alt="">
                    <div v-if="!selected.hideLabel">{{selected.label}}</div>
                </div>
            </template>

            <template v-slot:open>
                <sav-spinner v-if="loading" :size="10" />
                <list-items
                v-if="data"
                :data-src="data"
                :callback="end"
                :id="$options.name"
                ></list-items>
                <div v-if="$formTool.getFormData('buy-online') == 'shop'" @click="$modal.show('modal-other-sign')" class="font-black text-lg p-6 flex flex-col min-w-0 mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 hover:border-gray-350 hover:bg-gray-50 hover:shadow my-rounded">
                    Autre enseigne
                </div>
                <div v-if="$formTool.getFormData('buy-online') == 'online'" @click="$modal.show('modal-other-website')" class="font-black text-lg p-6 flex flex-col min-w-0 mb-3 break-words duration-200 bg-white border border-gray-300 rounded cursor-pointer border-1 hover:border-gray-350 hover:bg-gray-50 hover:shadow my-rounded">
                    Autre site web
                </div>

                <!-- Modal request -->
                <modal :name="'request-' + requestModalParams.libelle">
                    <sav-request-modal :displayName="requestModalParams.label" :libelle="requestModalParams.libelle" @close="hideRequestModal" />
                </modal>
                <!-- <button @click="displayRequestModal" class="block ml-auto mt-4 text-gray-900 font-light border border-gray-200 p-1.5 px-3 text-xs rounded-xl hover:bg-gray-100 duration-200">
                    <i class="fa-solid fa-circle-question mr-0.5"></i> {{requestModalParams.label}} {{$t('form.marque.introuvable')}}
                </button> -->
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'
import ModalSignNotFound from './ModalSignNotFound'

export default {
    name: 'sign',
    extends: FormCardExtension,

    data() {
        return {
            newSign: {
                name: null,
            },
            newWebsite: {
                url: null
            }
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.getNextBlock()
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            // Get api data
            let onlineId = 0 // 0 -> no online card, 1: only online, 2: only shop
            if (this.$formTool.getFormData('buy-online')) {
                onlineId = this.$formTool.getFormData('buy-online') == 'online' ? 1 : 2
            }
            let response = await apiService.post('getshopgroup', {
                id_app: this.$formTool.getFormData('device')[0].value.id,
                online: onlineId
            })
            this.data = this.$imgGridTool.convert('name', 'img', response.data.posts.post).map((shop) => ({...shop, hideLabel: shop.hideLabel == '1' ? true : false}))

            // Set Modal Requests
            this.requestModalParams = {
                label: this.$t('form.garantie.sign.enseigne'),
                libelle: 'shopgroup'
            }
            
            this.loading = false
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            if (this.selected) {
                this.$formTool.removeFormData('new-shop')
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
            this.nextBlock = this.getNextBlock()
        },

        getNextBlock() {
            // if (this.selected.selfcare_process_choice) {
            //     return this.$formTool.blockData(this.$options.name).next.chooseProcess
            // } else {
            //     return this.$formTool.blockData(this.$options.name).next.shop
            // }
            return this.$formTool.blockData(this.$options.name).next
        },

        signNotFound() {
            this.$modal.show(ModalSignNotFound, {displayName: this.requestModalParams.label, libelle: this.requestModalParams.libelle, end: this.end}, {height: 'auto', adaptive: true})
        },

        addNewSign() {
            if (!this.newSign.name) {
                this.$toast.error("Le nom de l'enseigne est obligatoire")
                return
            }

            let endObj = {
                ecommerce: this.$formTool.getFormData('buy-online') == 'shop' ? 0 : 1,
                hideLabel: false,
                id: null,
                img: null,
                label: this.newSign.name
            }

            this.end(endObj)

            this.$modal.hide('modal-other-sign')
        },

        addNewWebsite() {
            const isValidUrl = (t) => {
                var expression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi;
                var regex = new RegExp(expression);

                if (t.match(regex)) {
                    return true
                } else {
                    return false
                }
            }
            if (!this.newWebsite.url) {
                this.$toast.error("L'url est obligatoire")
                return
            }

            if (!isValidUrl(this.newWebsite.url)) {
                this.$toast.error('Url invalide')
                return
            }

            let endObj = {
                ecommerce: this.$formTool.getFormData('buy-online') == 'shop' ? 0 : 1,
                hideLabel: false,
                id: null,
                img: null,
                label: this.newWebsite.url
            }

            this.end(endObj)

            this.$modal.hide('modal-other-website')
        }
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/warranty/SignCard.vue